import React, { useEffect } from 'react';
import { BiX } from 'react-icons/bi';
import { CircularProgress } from '@material-ui/core';

import * as SM from '../../styles';
import * as S from '../ModalFinish/styles';

import Button from '../../../../newComponents/Button';

export type PagBankPixCharge = {
  orderId: number;
  status: string;
  qrCode?: string;
  copyPaste?: string;
  expirationDate?: string;
};

interface ModalPagBankPixProps {
  isOpen: boolean;
  charge: PagBankPixCharge | null;
  isWaiting: boolean;
  onClose: () => void;
}

const ModalPagBankPix: React.FC<ModalPagBankPixProps> = ({
  isOpen,
  charge,
  isWaiting,
  onClose,
}) => {
  useEffect(() => {
    if (!charge?.copyPaste) {
      return undefined;
    }

    return undefined;
  }, [charge]);

  return (
    <SM.CustomModal open={isOpen} onClose={onClose} closeAfterTransition>
      <div className="body">
        <div>
          <S.ModalHeader>
            <h1>Pagamento PIX PagBank</h1>
            <button type="button" onClick={onClose}>
              <BiX />
            </button>
          </S.ModalHeader>
          <S.ModalBody>
            <div className="payment" style={{ textAlign: 'center' }}>
              <h2>Peça para o cliente pagar o QR Code</h2>
              {!charge && <CircularProgress />}
              {charge?.qrCode && (
                <img
                  src={charge.qrCode}
                  alt="QR Code PIX"
                  style={{ width: 240, height: 240, margin: '16px auto' }}
                />
              )}
              {charge?.copyPaste && (
                <p style={{ wordBreak: 'break-all', fontSize: 12 }}>
                  {charge.copyPaste}
                </p>
              )}
              {isWaiting && (
                <p style={{ marginTop: 16 }}>Aguardando confirmação...</p>
              )}
            </div>
          </S.ModalBody>
          <S.ModalFooter>
            <Button full variant="outlined" onClick={onClose}>
              Fechar
            </Button>
          </S.ModalFooter>
        </div>
      </div>
    </SM.CustomModal>
  );
};

export default ModalPagBankPix;
